var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "page-title" }, [
      _vm._v(" " + _vm._s(_vm.$t("customerService.payin_search")) + " "),
    ]),
    _c(
      "div",
      { staticClass: "queryPay page-container" },
      [
        _c(
          "div",
          { staticClass: "filter-right-container" },
          [
            _c("div", { staticClass: "filter-container-tag" }, [
              _vm._v(" " + _vm._s(_vm.$t("components.activity")) + " "),
            ]),
            _c(
              "el-popover",
              { attrs: { placement: "bottom", trigger: "click" } },
              [
                _c("div", { staticClass: "filter-section-container" }, [
                  _c(
                    "div",
                    {
                      staticClass: "filter-content",
                      attrs: { id: "filter-content" },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "filter-item" },
                        [
                          _c("div", { staticClass: "filter-item-label" }, [
                            _vm._v(
                              _vm._s(_vm.$t("customerService.transaction_id"))
                            ),
                          ]),
                          _c("el-input", {
                            staticClass: "filter-item-value",
                            attrs: { type: "text", clearable: "" },
                            model: {
                              value: _vm.search.transaction_id,
                              callback: function ($$v) {
                                _vm.$set(_vm.search, "transaction_id", $$v)
                              },
                              expression: "search.transaction_id",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "filter-item" },
                        [
                          _c("div", { staticClass: "filter-item-label" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t("customerService.merchant_order_id")
                              )
                            ),
                          ]),
                          _c("el-input", {
                            staticClass: "filter-item-value",
                            attrs: { type: "text", clearable: "" },
                            model: {
                              value: _vm.search.mch_order_id,
                              callback: function ($$v) {
                                _vm.$set(_vm.search, "mch_order_id", $$v)
                              },
                              expression: "search.mch_order_id",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "filter-item" },
                        [
                          _c("div", { staticClass: "filter-item-label" }, [
                            _vm._v(
                              _vm._s(_vm.$t("customerService.payer_mobile"))
                            ),
                          ]),
                          _c("el-input", {
                            staticClass: "filter-item-value",
                            attrs: { type: "text", clearable: "" },
                            model: {
                              value: _vm.search.payer_mobile,
                              callback: function ($$v) {
                                _vm.$set(_vm.search, "payer_mobile", $$v)
                              },
                              expression: "search.payer_mobile",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "filter-item",
                          class: {
                            "border-red":
                              _vm.isShowBorderRed || _vm.isShowBorderInvoiceRed,
                          },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "filter-item-label" },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t("merchantAccount.complete_time")
                                  ) +
                                  " "
                              ),
                              _c("el-tooltip", [
                                _c(
                                  "div",
                                  {
                                    attrs: { slot: "content" },
                                    slot: "content",
                                  },
                                  [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "tips.customer_manager_complete_amount_same"
                                          )
                                        )
                                      ),
                                    ]),
                                  ]
                                ),
                                _c("span", [
                                  _c("i", {
                                    staticClass:
                                      "el-icon-warning-outline icon-warning-outline",
                                  }),
                                ]),
                              ]),
                            ],
                            1
                          ),
                          _c("el-date-picker", {
                            staticClass: "filter-item-value",
                            attrs: {
                              format: "yyyy-MM-dd",
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              "default-time": ["00:00:00", "23:59:59"],
                              type: "daterange",
                              "range-separator": "~",
                              "start-placeholder": _vm.$t(
                                "components.start_date"
                              ),
                              "end-placeholder": _vm.$t("components.end_date"),
                            },
                            model: {
                              value: _vm.search.response_times,
                              callback: function ($$v) {
                                _vm.$set(_vm.search, "response_times", $$v)
                              },
                              expression: "search.response_times",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "filter-item" },
                        [
                          _c(
                            "div",
                            { staticClass: "filter-item-label" },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t("customerService.transaction_amount")
                                  ) +
                                  " "
                              ),
                              _c("el-tooltip", [
                                _c(
                                  "div",
                                  {
                                    attrs: { slot: "content" },
                                    slot: "content",
                                  },
                                  [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "tips.customer_manager_complete_amount_same"
                                          )
                                        )
                                      ),
                                    ]),
                                  ]
                                ),
                                _c("span", [
                                  _c("i", {
                                    staticClass:
                                      "el-icon-warning-outline icon-warning-outline",
                                  }),
                                ]),
                              ]),
                            ],
                            1
                          ),
                          _c("el-input", {
                            staticClass: "filter-item-value",
                            class: { "border-red": _vm.isShowBorderRed },
                            attrs: { type: "text", clearable: "" },
                            model: {
                              value: _vm.search.transaction_amount,
                              callback: function ($$v) {
                                _vm.$set(_vm.search, "transaction_amount", $$v)
                              },
                              expression: "search.transaction_amount",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "filter-item" },
                        [
                          _c(
                            "div",
                            { staticClass: "filter-item-label" },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t(
                                      _vm.$store.getters.isMX
                                        ? "customerService.ph_invoice_no"
                                        : "customerService.invoice_no"
                                    )
                                  ) +
                                  " "
                              ),
                              _c("el-tooltip", [
                                _c(
                                  "div",
                                  {
                                    attrs: { slot: "content" },
                                    slot: "content",
                                  },
                                  [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "tips.customer_manager_complete_invocice_same"
                                          )
                                        )
                                      ),
                                    ]),
                                  ]
                                ),
                                _c("span", [
                                  _c("i", {
                                    staticClass:
                                      "el-icon-warning-outline icon-warning-outline",
                                  }),
                                ]),
                              ]),
                            ],
                            1
                          ),
                          _c("el-input", {
                            staticClass: "filter-item-value",
                            class: { "border-red": _vm.isShowBorderInvoiceRed },
                            attrs: { type: "text", clearable: "" },
                            model: {
                              value: _vm.search.channel_reference_no,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.search,
                                  "channel_reference_no",
                                  $$v
                                )
                              },
                              expression: "search.channel_reference_no",
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                  _c("div", { staticClass: "filter-operate" }, [
                    _c(
                      "div",
                      { staticClass: "filter-operate-right" },
                      [
                        _c(
                          "el-button",
                          {
                            staticClass: "search-btn mb-10",
                            on: { click: _vm.onClickReset },
                          },
                          [_vm._v(_vm._s(_vm.$t("components.clear")))]
                        ),
                        _c(
                          "el-button",
                          {
                            staticClass: "search-btn mb-10",
                            attrs: { type: "primary", icon: "el-icon-search" },
                            on: { click: _vm.onClickSearchBtn },
                          },
                          [_vm._v(_vm._s(_vm.$t("components.search")))]
                        ),
                      ],
                      1
                    ),
                  ]),
                ]),
                _c(
                  "el-button",
                  {
                    staticClass: "mb-10 mr-12",
                    attrs: { slot: "reference", type: "info", plain: "" },
                    slot: "reference",
                  },
                  [
                    _c("svg-icon", {
                      attrs: { "class-name": "mr-10", "icon-class": "filter" },
                    }),
                    _vm._v(_vm._s(_vm.$t("components.filter"))),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "tableContainer" },
          [
            _c(
              "el-table",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.listLoading,
                    expression: "listLoading",
                  },
                ],
                staticStyle: { width: "100%" },
                attrs: {
                  data: _vm.tableData,
                  stripe: "",
                  fit: "",
                  "highlight-current-row": "",
                },
              },
              [
                _c("el-table-column", {
                  attrs: {
                    label: _vm.$t("customerService.transaction_id"),
                    align: "center",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("span", [
                            _vm._v(_vm._s(scope.row.transaction_id)),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    label: _vm.$t("customerService.merchant_order_id"),
                    align: "center",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("span", [
                            _vm._v(_vm._s(scope.row.merchant_order_id)),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    "min-width": "110",
                    label: _vm.$t("merchant.payment_channel"),
                    align: "center",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("span", [_vm._v(_vm._s(scope.row.channel_code))]),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    "min-width": "150",
                    label: _vm.$t("customerService.transaction_status"),
                    align: "center",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "el-tag",
                            {
                              staticClass: "tag-status tag-custom",
                              attrs: {
                                type: _vm.getPayTransactionStatusStyle(
                                  scope.row.transaction_status
                                ),
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.getPayTransactionStatusLabel(
                                    scope.row.transaction_status
                                  )
                                )
                              ),
                            ]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    label: _vm.$t("customerService.transaction_amount"),
                    align: "center",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm._f("toDivideWithDot")(
                                  scope.row.transaction_amount
                                )
                              )
                            ),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    label: _vm.$t("merchant.service_fee"),
                    align: "center",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm._f("toDivideWithDot")(scope.row.fee_split)
                              )
                            ),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    label: _vm.$t("customerService.create_time"),
                    align: "center",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("span", [
                            _vm._v(_vm._s(scope.row.transaction_create_time)),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    "min-width": "110",
                    label: _vm.$t("merchantAccount.complete_time"),
                    align: "center",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("span", [
                            _vm._v(_vm._s(scope.row.transaction_return_time)),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    label: _vm.$t("components.operation"),
                    align: "center",
                    "min-width": "130",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "info", size: "small", plain: "" },
                              on: {
                                click: function ($event) {
                                  return _vm.onClickDetailBtn(scope.row)
                                },
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("components.view_details")) +
                                  " "
                              ),
                            ]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "pagination-container" },
          [
            !_vm.listLoading
              ? _c("paginator", {
                  attrs: { "list-query": _vm.listQuery },
                  on: { "paginator-change": _vm.confirm },
                })
              : _vm._e(),
          ],
          1
        ),
        _c("payin-details-modal", {
          ref: "paymentDetailsModal",
          attrs: { "detail-id": _vm.detailId },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }